import { styled } from 'styled-components';
import { device } from '@/styles/helpers';
import { ScPlayButton } from '../../PlayButton/styled';
import { enablePointerEvents } from '../GameCard/styled';

export const ScSmallGameCardBack = styled.div`
  position: relative;
  opacity: 0;
  transition: opacity 0.1s ease-in-out;
  width: 100%;
  height: 100%;
  padding: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
`;

export const ScSmallGameCardInner = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  background: linear-gradient(90deg, #131314 0%, #1c1c1e 100%);
  border-radius: 12px;

  & .cover-image {
    border-radius: 12px;
  }

  ${ScSmallGameCardBack} {
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.8) 0%,
      rgba(0, 0, 0, 0.8) 100%
    );
  }

  &:hover {
    ${ScSmallGameCardBack} {
      opacity: 1;
    }

    @media (${device.mobile}) {
      ${ScPlayButton} {
        pointer-events: none;
        animation: ${enablePointerEvents} 0.5s forwards 0.5s;
      }
    }
  }
`;
